<template>
  <div class="app-secondary-body">
    <cash-hero-navbar :bright="true" />
    <div class="content-margin-top">
      <router-view />
    </div>
    <v3-cash-hero-footer />
  </div>
</template>

<script>
import CashHeroNavbar from '../partials/CashHeroNavbar'
import V3CashHeroFooter from '@/partials/v3/V3CashHeroFooter'

export default {
  name: 'Secondary',
  components: { V3CashHeroFooter, CashHeroNavbar },
  mounted () {
    (function ($) {
      'use strict'
      const navbarCollapse = function () {
        if ($('#mainNav').offset().top > 72) {
          $('#mainNav').addClass('navbar-scrolled')
        } else {
          $('#mainNav').removeClass('navbar-scrolled')
        }
      }
      navbarCollapse()
      $(window).scroll(navbarCollapse)
    })(jQuery)
  }
}
</script>

<style>
  html, body {
    height: auto !important;
  }

  .content-margin-top {
    padding-top: 7.5rem;
  }

  .app-secondary-body {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-size: contain;
    background-color: #ffffffaa;
    background-blend-mode: overlay;
    background-position: center;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 991px) {
    .content-margin-top {
      padding-top: 4rem;
    }

    .app-secondary-body {
      background-position: bottom;
      background-size: cover;
    }

  }
</style>
